import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'vendorName',
    header: 'Vendor',
    type: 'text',
  },
  {
    key: 'contactName',
    header: 'Contact Name',
    type: 'text',
  },
  {
    key: 'email',
    header: 'Email',
    type: 'email',
    width: 35,
  },
  {
    key: 'phone',
    header: 'Phone',
    type: 'number',
  },
];
